import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tags',
})
export class TagsPipe implements PipeTransform {
  transform(tags: any[], limit: number = 4): any[] {
    if (!tags || !Array.isArray(tags)) return [];

    if (tags.length <= limit) {
      return tags;
    } else {
      return tags.slice(0, limit);
    }
  }
}
